import { formatDate } from "../../../myProfile/utils";
import { addOneHourToTime } from "../../utils";

function BusyEvents({
  isBusyOpen,
  busyAppointmentInfo,
  allUsers,
  setIsBusyOpen,
}) {
  return (
    <div>
      {" "}
      {isBusyOpen && (
        <div className={"busyWrapper"}>
          <div className={"busyContainer"}>
            <div className={"modalContent"}>
              <h1 className={"busyTitle"}>Zauzeti termini</h1>

              <div className={"busyContent"}>
                {busyAppointmentInfo.map((event, index) => (
                  <div key={index} className={"busyItem"}>
                    {formatDate(event?.date) +
                      " " +
                      event?.timeFrom +
                      "-" +
                      addOneHourToTime(event?.timeFrom)}{" "}
                    -{" "}
                    {event.therapistId
                      ? allUsers.find((user) => user.id === event.therapistId)
                          ?.firstName +
                        " " +
                        allUsers.find((user) => user.id === event.therapistId)
                          ?.lastName
                      : allUsers.find((user) => user.id === event.creatorId)
                          ?.firstName +
                        " " +
                        allUsers.find((user) => user.id === event.creatorId)
                          ?.lastName}
                  </div>
                ))}
              </div>
            </div>
            <div className={"busyBtn"}>
              <button
                className={"btnOk"}
                onClick={() => {
                  setIsBusyOpen(false);
                }}
              >
                U redu
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

export default BusyEvents;
